import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

import { AvailableModelRepoItem } from './type';

export const UrlMap = () => ({
  list: () => `${PREFIX.vapis_dc_ws(GROUPS.image)}/stack-artifacts/available-model-repos`,
});

export interface AvailableModelRepoQuery {
  page?: number;
  limit?: number;
  'name[like]'?: string;
}

/** 获取可用模型仓库列表（支持分页与名称搜索） */
export function getAvailableModelRepos(params?: AvailableModelRepoQuery): Promise<{ items: AvailableModelRepoItem[]; totalItems: number }> {
  return get(UrlMap().list(), undefined, { params });
}
